import { css } from "emotion";
import H3 from "../global/H3";
import H4 from "../global/H4";
import Image from "../Image";
import Slider from "./Slider";
import { max } from "../../utils/CssUtils";
import ColorServices from "../../services/ColorServices";

const sportFace = require("../../assets/humanitixFaces/sport.svg");
const musicFace = require("../../assets/humanitixFaces/music.svg");
const foodFace = require("../../assets/humanitixFaces/food.svg");
const businessFace = require("../../assets/humanitixFaces/business.svg");
const filmFace = require("../../assets/humanitixFaces/film.svg");
const festivalsFace = require("../../assets/humanitixFaces/festivals.svg");
const comedyFace = require("../../assets/humanitixFaces/comedy.svg");
const workshopFace = require("../../assets/humanitixFaces/workshop.svg");

const sportPicture = require("../../assets/home/categories/sport.png");
const musicPicture = require("../../assets/home/categories/music.png");
const foodPicture = require("../../assets/home/categories/food.png");
const businessPicture = require("../../assets/home/categories/business.png");
const filmPicture = require("../../assets/home/categories/film.png");
const festivalsPicture = require("../../assets/home/categories/festival.png");
const comedyPicture = require("../../assets/home/categories/comedy.png");
const workshopPicture = require("../../assets/home/categories/workshop.png");

const categoryCardWrapper = css({
  width: 180,
  height: 280,
  padding: 10,
  borderRadius: 4,
  whiteSpace: "initial",
  backgroundColor: ColorServices.getColor("purpleMid"),
  textAlign: "center",
  marginRight: 0,
  position: "relative",
  marginBottom: 0,
  img: {
    borderRadius: 4,
    "&:first-of-type": {
      marginBottom: 16
    }
  },
  h4: {
    color: ColorServices.getColor("white"),
    position: "absolute",
    bottom: 16,
    width: "calc(100% - 20px)"
  }
});

const CategoryCard = ({ categoryObj, locale = "" }) => {
  const link = locale ? `/${locale}/search` : "/search";
  return (
    <a href={`${link}?category[]=${encodeURIComponent(categoryObj.title)}`}>
      <div className={categoryCardWrapper}>
        <Image imageURL={categoryObj.img} alt="" />
        <Image imageURL={categoryObj.icon} alt="" />
        <H4>{categoryObj.title}</H4>
      </div>
    </a>
  );
};

const categories = [
  {
    title: "Sports & Fitness",
    img: sportPicture,
    icon: sportFace,
    link: ""
  },
  {
    title: "Music",
    img: musicPicture,
    icon: musicFace,
    link: ""
  },
  {
    title: "Food & Drink",
    img: foodPicture,
    icon: foodFace,
    link: ""
  },
  {
    title: "Business",
    img: businessPicture,
    icon: businessFace,
    link: ""
  },
  {
    title: "Film & Media",
    img: filmPicture,
    icon: filmFace,
    link: ""
  },
  {
    title: "Festivals",
    img: festivalsPicture,
    icon: festivalsFace,
    link: ""
  },
  {
    title: "Comedy",
    img: comedyPicture,
    icon: comedyFace,
    link: ""
  },
  {
    title: "Workshop",
    img: workshopPicture,
    icon: workshopFace,
    link: ""
  }
];

const Categories = props => {
  const { locale, hideButtons = false } = props;
  const wrapper = css({
    maxWidth: hideButtons ? 1040 : 1130,
    margin: "0 auto",
    h3: {
      color: ColorServices.getColor("purpleMid"),
      marginBottom: 32
    },
    padding: hideButtons ? "0 15px" : "0 45px",
    [max(768)]: {
      padding: "0 15px"
    }
  });

  return (
    <div className={wrapper}>
      <H3>Explore trending categories</H3>
      <Slider hideButtons={hideButtons} gap={16}>
        {categories.map(category => (
          <CategoryCard categoryObj={category} locale={locale} />
        ))}
      </Slider>
    </div>
  );
};

export default Categories;
